import React, { useEffect } from 'react';
import { Box, Image, keyframes } from '@chakra-ui/react';

const shimmer = keyframes`
  0% { transform: translateX(-150%); }
  50% { transform: translateX(0%); }
  100% { transform: translateX(150%); }
`;

const SplashScreen = ({ onFinish, duration = 4000 }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      if (onFinish) onFinish();
    }, duration);
    return () => clearTimeout(timer);
  }, [onFinish, duration]);

  return (
    <Box
      minH="100vh"
      bg="linear-gradient(160deg, #ffffff, #f4f4f0)"
      display="flex"
      alignItems="center"
      justifyContent="center"
      position="relative"
      overflow="hidden"
      px={{ base: 4, md: 8 }}
    >
      <Box position="absolute" inset="0" bg="radial-gradient(circle at 20% 20%, rgba(201,162,76,0.16), transparent 38%)" />
      <Box position="absolute" inset="0" bg="radial-gradient(circle at 80% 80%, rgba(147,200,230,0.14), transparent 40%)" />

      <Box position="relative" zIndex={1} maxW="980px" w="100%">
        <Box
          position="absolute"
          inset="0"
          bg="linear-gradient(120deg, transparent, rgba(255,255,255,0.28), transparent)"
          opacity={0.7}
          animation={`${shimmer} 2.4s linear infinite`}
          pointerEvents="none"
        />
        <Box position="relative">
          <Image
            src="/splash-130.png"
            alt="Loja Maçônica Estrela Caldense"
            w="100%"
            borderRadius="18px"
            boxShadow="0 20px 60px rgba(0,0,0,0.25)"
            bg="white"
          />
          <Box
            position="absolute"
            inset="0"
            bg="linear-gradient(100deg, rgba(255,255,255,0) 30%, rgba(255,255,255,0.28) 50%, rgba(255,255,255,0) 70%)"
            mixBlendMode="screen"
            animation={`${shimmer} 2.8s linear infinite`}
            pointerEvents="none"
            borderRadius="18px"
          />
        </Box>
      </Box>
    </Box>
  );
};

export default SplashScreen;
